module.exports = __webpack_public_path__ + "img/keno_head.edbca9e3.jpg";